// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"68a173f6","248":"0441d26e","327":"33fd6db4","379":"4784b45c","514":"2e3f3ecc","536":"1afbf03d","776":"2015c57a","865":"94bec3b7","900":"fe1ea0bc","924":"644c1325"}[chunkId] + ".chunk.js";
};